module.exports = __webpack_public_path__ + "img/americalexpress.a51377cf.png";